import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Component, ElementRef, Input, Output, Directive, TemplateRef, ViewChild, ViewContainerRef, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { DomService, Platform } from 'alyle-ui/core';
var Origin = /** @class */ (function () {
    function Origin() {
    }
    return Origin;
}());
export { Origin };
var LyTemplateMenu = /** @class */ (function () {
    function LyTemplateMenu(_viewContainerRef) {
        this._viewContainerRef = _viewContainerRef;
    }
    LyTemplateMenu.prototype.ngOnInit = function () {
    };
    LyTemplateMenu.prototype.tmpl = function (template) {
        this._vcr.createEmbeddedView(template);
    };
    LyTemplateMenu.prototype.ngOnDestroy = function () {
        console.log('desst');
    };
    LyTemplateMenu.decorators = [
        { type: Component, args: [{
                    selector: 'ly-template-menu',
                    template: "\n  <div #container></div>\n  ",
                    styles: ["\n    :host {\n      position: absolute;\n      display: block;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n    }\n  "]
                },] },
    ];
    /** @nocollapse */
    LyTemplateMenu.ctorParameters = function () { return [
        { type: ViewContainerRef, },
    ]; };
    LyTemplateMenu.propDecorators = {
        "_vcr": [{ type: ViewChild, args: ['container', { read: ViewContainerRef },] },],
    };
    return LyTemplateMenu;
}());
export { LyTemplateMenu };
var LyMenu = /** @class */ (function () {
    function LyMenu(elementRef, _viewContainerRef, domService, cd, sanitizer) {
        this.elementRef = elementRef;
        this._viewContainerRef = _viewContainerRef;
        this.domService = domService;
        this.cd = cd;
        this.sanitizer = sanitizer;
        this.isIni = false;
        this.stateBg = false;
        this.widthTarget = 0;
        this.heightTarget = 0;
        this.rootMenu = {
            top: 0,
            left: 0,
        };
        this.opened = false;
        this._anchorOrigin = { horizontal: 'left', vertical: 'top' };
        this._targetOrigin = { horizontal: 'left', vertical: 'top' };
        this._targetPosition = new BehaviorSubject(null);
        this.open = new EventEmitter();
        this.close = new EventEmitter();
    }
    LyMenu.prototype.ngOnChanges = function (changes) {
        if (changes['_targetOrigin']) {
            Promise.resolve(null).then(function () {
                if (true) {
                    // console.log('changes[target-origin]', changes['_targetOrigin']);
                }
            });
        }
    };
    LyMenu.prototype.updateTargetPosition = function () {
        var vertical = '0%', horizontal = '0%';
        if (this._targetOrigin.horizontal === 'middle') {
            horizontal = '-50%';
        }
        else if (this._targetOrigin.horizontal === 'right') {
            horizontal = '-100%';
        }
        if (this._targetOrigin.vertical === 'center') {
            vertical = '-50%';
        }
        else if (this._targetOrigin.vertical === 'bottom') {
            vertical = '-100%';
        }
        var menuStyle = this.sanitizer.bypassSecurityTrustStyle("translate3d(" + horizontal + ", " + vertical + ", 0) scale3d(1, 1, 1)");
        this._targetPosition.next(menuStyle);
    };
    // get size
    // get size
    LyMenu.prototype.target = 
    // get size
    function (_element) {
        var element = _element;
        return {
            'width': element.offsetWidth || 0,
            'height': element.offsetHeight || 0,
            'left': element.offsetWidth || 0,
            'top': 0,
        };
    };
    Object.defineProperty(LyMenu.prototype, "rootStylePosition", {
        get: function () {
            var top = 0;
            var left = 0;
            // let topTarget: any = 0;
            // let leftTarget: any = 0;
            // for _anchorOrigin
            if (this._anchorOrigin.vertical === 'center') {
                // anchor origin
                top = (this.rootMenu.height / 2);
            }
            else if (this._anchorOrigin.vertical === 'bottom') {
                top = (this.rootMenu.height);
            }
            if (this._anchorOrigin.horizontal === 'middle') {
                // anchor origin
                left = (this.rootMenu.width / 2);
            }
            else if (this._anchorOrigin.horizontal === 'right') {
                left = (this.rootMenu.width);
            }
            // // for target origing
            // if (this._targetOrigin.vertical == 'center') {
            //   // anchor origin
            //   topTarget = -(this.heightTarget / 2);
            // } else if (this._targetOrigin.vertical == 'bottom') {
            //   topTarget = -(this.heightTarget);
            // }
            // if (this._targetOrigin.horizontal == 'middle') {
            //   // leftTarget = (this.target(this._menuElement).width / 2);
            //   leftTarget = -(this.widthTarget / 2);
            // } else if (this._targetOrigin.horizontal == 'right') {
            //   // leftTarget = (this.target(this._menuElement).width);
            //   leftTarget = -(this.widthTarget);
            // }
            return {
                top: top,
                left: left,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LyMenu.prototype, "rootStyle", {
        get: function () {
            var menuPosition = this.rootMenu;
            var positionFinal = menuPosition;
            if (this._anchorOrigin) {
            }
            return positionFinal;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LyMenu.prototype, "targetOrigin", {
        get: function () {
            return (this._targetOrigin.horizontal === 'middle' ? 'center' : this._targetOrigin.horizontal) + " " + this._targetOrigin.vertical + " 0";
        },
        enumerable: true,
        configurable: true
    });
    LyMenu.prototype.toggleMenu = function () {
        this.opened === false ? this.showMenu() : this.hiddeMenu();
    };
    LyMenu.prototype.showMenu = function () {
        this.menuAnimationsState = 'in';
        this.menuContentRef = this.domService.attach(this._viewContainerRef, LyTemplateMenu, this.templateRef);
        // this.menuContentElement = this.domService.getDomElementFromComponentRef(this.menuContentRef);
        // this.domService.addChild(this.menuContentElement);
        this.updateTargetPosition();
        this.opened = true;
        this.stateBg = true;
        this.open.emit(null);
    };
    LyMenu.prototype.hiddeMenu = function () {
        this.close.emit(null);
        this.opened = false;
        this.stateBg = false;
        // this.menuAnimationsState = 'end';
        this._destroyMenu();
    };
    LyMenu.prototype._destroyMenu = function () {
        // if (this.menuContentRef) {
        this.domService.destroyRef(this.menuContentRef, 0);
        // }
    };
    LyMenu.prototype.ngOnInit = function () {
    };
    LyMenu.prototype.ngAfterViewInit = function () {
    };
    LyMenu.prototype.ngOnDestroy = function () {
        if (Platform.isBrowser) {
            this._destroyMenu();
        }
    };
    LyMenu.decorators = [
        { type: Component, args: [{
                    selector: 'ly-menu',
                    styles: [".ly-menu { display: inline-block; position: fixed; padding: 8px 0px; max-height: 248px; overflow: auto; user-select: none; z-index: 1000; opacity: 0; min-width: 84px; width: fit-content; transform: scale3d(0, 0, 0); box-shadow: rgba(0, 0, 0, 0.15) 0 2px 6px, rgba(0, 0, 0, 0.15) 0 1px 4px; border-radius: 2px; transition: transform 175ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 275ms ease-in 0ms; will-change: opacity, transform; font-family: Roboto, \"Helvetica Neue\", sans-serif; } .ly-list-x { z-index: 0; max-height: 100%; } .ly-menu /deep/ ly-menu { position: absolute; } .ly-menu.ly-list { position: relative; transform: scale3d(1, 1, 1); transition: all 0ms linear 0ms; } :host.ly-list .ly-menu { position: relative; transform: scale(1, 1); transition: all 0ms linear 0ms; opacity: 1; } :host.ly-list .ly-background-menu { pointer-events: none; } .ly-menu.ly-menu-opened { transform: scale3d(1, 1, 1); opacity: 1; } .ly-background-menu { position: absolute; top: 0; bottom: 0; left: 0; right: 0; background: transparent; z-index: 999; user-select: none; pointer-events: none; } .ly-background-on { pointer-events: all !important; pointer-events: auto !important; } ::ng-deep button[ly-menu-item] { display: block; min-height: 48px; border-radius: 0; width: 100%; } "],
                    animations: [
                        trigger('menu', [
                            transition(':leave', animate('150ms 50ms linear', style({ opacity: 0 }))),
                            state('in', style({
                                opacity: 1
                            })),
                            transition(':enter', animate('100ms linear'))
                        ])
                    ],
                    template: "\n  <ng-template>\n    <div #_menu [@menu]=\"menuAnimationsState\"\n      class=\"ly-menu\"\n      bg=\"main\"\n      color=\"colorText\"\n      [style.transform-origin]=\"targetOrigin\"\n      [style.top.px]=\"rootStyle.top + rootStylePosition.top\"\n      [style.left.px]=\"rootStyle.left + rootStylePosition.left\"\n      [style.transform]=\"_targetPosition | async\">\n      <div class=\"ly-menu-content\">\n        <ng-content></ng-content>\n      </div>\n    </div>\n    <div\n    class=\"ly-background-menu ly-background-on\"\n    (click)=\"hiddeMenu()\"></div>\n  </ng-template>\n  ",
                    exportAs: 'lyMenu',
                    preserveWhitespaces: false
                },] },
    ];
    /** @nocollapse */
    LyMenu.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: ViewContainerRef, },
        { type: DomService, },
        { type: ChangeDetectorRef, },
        { type: DomSanitizer, },
    ]; };
    LyMenu.propDecorators = {
        "opened": [{ type: Input },],
        "_anchorOrigin": [{ type: Input, args: ['anchor-origin',] },],
        "_targetOrigin": [{ type: Input, args: ['target-origin',] },],
        "_menuElement": [{ type: ViewChild, args: ['_menu',] },],
        "templateRef": [{ type: ViewChild, args: [TemplateRef,] },],
        "open": [{ type: Output },],
        "close": [{ type: Output },],
    };
    return LyMenu;
}());
export { LyMenu };
var LyMenuTriggerFor = /** @class */ (function () {
    function LyMenuTriggerFor(elementRef) {
        this.elementRef = elementRef;
    }
    LyMenuTriggerFor.prototype.targetPosition = function () {
        var element = this.elementRef.nativeElement;
        var rect = element.getBoundingClientRect();
        var result = {
            'width': rect.width,
            'height': rect.height,
            'left': rect.left,
            'top': rect.top,
        };
        return result;
    };
    LyMenuTriggerFor.prototype._handleClick = function (e) {
        this.lyMenuTriggerFor.rootMenu = this.targetPosition();
        this.lyMenuTriggerFor.toggleMenu();
    };
    LyMenuTriggerFor.decorators = [
        { type: Directive, args: [{
                    selector: '[lyMenuTriggerFor]',
                    // tslint:disable-next-line:use-host-property-decorator
                    host: {
                        '(click)': '_handleClick($event)'
                    }
                },] },
    ];
    /** @nocollapse */
    LyMenuTriggerFor.ctorParameters = function () { return [
        { type: ElementRef, },
    ]; };
    LyMenuTriggerFor.propDecorators = {
        "lyMenuTriggerFor": [{ type: Input, args: ['lyMenuTriggerFor',] },],
    };
    return LyMenuTriggerFor;
}());
export { LyMenuTriggerFor };
//# sourceMappingURL=menu.js.map